export default {
  invitation: {
    title: 'Invitation',
    banner_title: 'Up to {num}% Rebates with Our Referral Program',
    banner_desc: 'If you want more, you can also join the alliance special plan to share the growth benefits of Biconomy',
    banner_link: 'Join Our Affiliate Program',
    banner_card_title: 'Invite A Friend To Get Rebates',
    banner_card_info1: 'Rebate Ratio (spot)',
    banner_card_info2: 'Share of the BIT reward weight',
    banner_card_Increase: 'Increase My Rewards',
    banner_card_link1: 'Referral Link',
    banner_card_link2: 'Referral Code',
    banner_card_btn: 'Invite Now',
    banner_card_learn: 'Learn the rules',
    overview: 'Referral Overview',
    number: 'Number of invitees',
    circle: 'Your rewards are automatically distributed to the spot account',
    card_1: 'Cumulative Rebate (USDT)',
    card_2: 'Cumulative Share (BIT)',
    card_3: 'Jackpot Amount',
    card_4: 'Lottery Time',
    data_title: 'My Referral Data',
    tab_1: 'Invitation History',
    tab_2: 'Rebate Record',
    tab_3: 'Divide Records',
    head_2: 'Registration time',
    head_3: 'Referral Rate',
    head_4: 'Share equal rights',
    head_5: 'account status',
    head_6: 'My Rebate Income',
    head_7: 'My share of Income',
    rebateHead_3: 'Transaction Type',
    faqs_title_1: 'What are the rules for sharing BIT?',
    faqs_title_2: 'How much BIT can each person get?',
    faqs_title_3: 'What are the reward distribution rules for invitation rebates?',
    faqs_title_4: 'What is an effective user？',
    faqs_desc_1:
      'Channel partners are required to regularly promote acquisition on their own platforms to attract new users, Biconomy will periodically evaluate based on the number of new users and newly increased transaction volume from the channel on a quarterly basis. The standards are shown in the table above. Those who failed to meet the standard will have commission rebate rights reduced until the Affiliate status is lifted.',
    faqs_desc_2:
      'Channel partners are required to abide by the Biconomy brand usage rules, and are not allowed to use the Biconomy brand without authorization. Biconomy does not provide credit endorsements on any action taken by the Channel partners. ',
    faqs_desc_3:
      "During the period of bit distribution in each phase, the platform will take a random snapshot of the user's position. According to the partition weight corresponding to the user's position in each phase, the number of bits that the user can share in the snapshot phase is calculated. After the amount in the phase is accumulated, it is the total amount of bits that the user can share this time, Bit available to a single user = (number of invited users in the user cycle * weight / number of all invited users in the cycle * weight) * bonus pool.",
    faqs_desc_4:
      'The invitee must register and become an effective user before he can bring a rebate reward to the invitee; There is no upper limit on the amount that can be obtained by the invited rebate, and there is no upper limit on the number of people invited. The rebate reward will be automatically distributed to the spot account after being reviewed on T + 1 day.',
    faqs_desc_5:
      'complete KYC and the deposit is at least equivalent to {num} USDT, which is defined as "valid invited users", the cancellation and re registration of registered users are regarded as invalid invited users, and no reward is provided; The final right of interpretation belongs to Biconomy.',
    faqs_desc_6:
      'When calculating the rebate percentage, the platform will take a random snapshot of the number of BITs in your positions. To ensure that your rebate percentage is optimal, please ensure that your positions remain stable for at least ten days.',
    modal_title: 'Rebate Ratio',
    modal_current: 'Current Level',
    level: 'Level',
    modal_item1: 'Grade',
    modal_item2: 'Rebate (spot)',
    modal_item3: 'Position',
    modal_item4: 'BIT share reward weight',
  },
  enable: 'Enable',
  disable: 'Disable',
};
